import type { RouteRecordRaw } from 'vue-router'
import device from './crae'
import brain from './crae-brain'

// 复用同一份页面与菜单定义，旧入口继续保留。
function reusePages(source: RouteRecordRaw, prefix: string) {
  return (source.children || []).filter(page => !(prefix === 'brain' && page.path === 'concurrency')).map((page): RouteRecordRaw => {
    const result = { ...page }
    result.path = `${prefix}/${page.path}`
    result.name = page.name ? `Craenew${String(page.name)}` : undefined
    if (typeof result.redirect === 'string') {
      result.redirect = result.redirect.replace(source.path, `/craenew/${prefix}`)
    }
    result.meta = {
      ...page.meta,
      activeMenu: typeof page.meta?.activeMenu === 'string'
        ? page.meta.activeMenu.replace(source.path, `/craenew/${prefix}`)
        : undefined,
      // 新旧入口使用相同组件但不同数据源，分别按路由名称创建页面。
      cache: false,
      ...(page.path === 'tenant/index' ? { menu: false } : {}),
      ...(page.path === 'tenants' ? { menu: false } : {}),
      ...(page.path === 'message-receive' ? { auth: 'crae:robot:list' } : {}),
    }
    if ((prefix === 'device' && page.path === 'tenant/index') || (prefix === 'brain' && page.path === 'tenants')) {
      result.redirect = '/craenew/tenants'
      result.meta.auth = ['crae:robot:list', 'crae-brain:tenant-config:list']
    }
    return result
  })
}

const pages = [...reusePages(device, 'device'), ...reusePages(brain, 'brain')]
const permissions = [...new Set(pages.flatMap(page => typeof page.meta?.auth === 'string'
  ? [page.meta.auth]
  : (page.meta?.auth || [])))]

const routes: RouteRecordRaw = {
  path: '/craenew',
  name: 'Craenew',
  component: () => import('@/layouts/index.vue'),
  meta: { title: '新CRAE', icon: 'i-ant-design:robot-outlined', auth: permissions },
  children: [
    {
      path: 'tenants',
      name: 'CraenewTenants',
      component: () => import('@/views/crae/tenant/index.vue'),
      meta: { title: '租户管理', icon: 'i-ant-design:setting-outlined', auth: ['crae:robot:list', 'crae-brain:tenant-config:list'] },
    },
    {
      path: 'customers',
      name: 'CraenewCustomers',
      redirect: '/craenew/tenants',
      meta: { title: '租户管理', menu: false, auth: 'crae-brain:tenant-config:list' },
    },
    {
      path: 'employees',
      name: 'CraenewEmployees',
      component: () => import('@/views/craenew/employees/index.vue'),
      meta: { title: '员工与接入', icon: 'i-ant-design:team-outlined', auth: 'crae-brain:tenant-config:list', cache: false },
    },
    ...pages,
  ],
}

export default routes
